import React, { useState, useMemo } from 'react';
import { Proposal } from "./Proposal.jsx";
import Pagination from "./Pagination/Pagination.jsx";

export function ProposalList({proposals, answeredProposals, setAnsweredProposals, configuration}) {
    let PageSize = 4;
    const [currentPage, setCurrentPage] = useState(1);

    const currentPageData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        return proposals.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, proposals]);

    function markProposalAnswered(proposalId, answer) {
        let answers = [...answeredProposals];
        let item = answers.find(i => i.proposal == proposalId);
        if (item) {
            item.answer = answer;
        } else { 
            answers.concat({proposal: proposalId, answer: answer});
        }
        setAnsweredProposals(answers);
    }
    function getAnswer(proposalId) {
        let item = answeredProposals.find(i => i.proposal == proposalId);
        if (item) return item.answer;
        return null;
    }
    return (
        <>
        <div className="proposals-by-topic-list">
            {currentPageData.map(proposal =>
                <Proposal
                    key={proposal.pk}
                    proposal={proposal}
                    configuration={configuration}
                    answer={getAnswer(proposal.pk)}
                    onAnswered={(answer) => markProposalAnswered(proposal.pk, answer)}
                    />
            )}
        </div>
        <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={proposals.length}
            pageSize={PageSize}
            onPageChange={page => setCurrentPage(page)}
        />
        </>
    )
}
